module.exports = __webpack_public_path__ + "static/media/haifa.eabd5d44.jpeg";